import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input", "submitButton"];

  connect() {
    this.validateInput();
  }

  validateInput() {
    const input = this.inputTarget;
    const value = parseInt(input.value, 10);

    const errorDiv = document.getElementById("error_message");
    const submitBtn = this.submitButtonTarget;

    errorDiv.style.display = "none";
    errorDiv.textContent = "";

    if (input.value === "") {
      submitBtn.disabled = true;
      return;
    }

    if (isNaN(value) || value <= 0) {
      errorDiv.textContent =
        "Solo se aceptan números enteros positivos";
      errorDiv.style.display = "block";
      submitBtn.disabled = true;
      return;
    }

    submitBtn.disabled = false;
  }

  guardar(e) {
    const internacion =
    document.querySelector('[name="internacion"]')?.value;
    if (internacion == "true") {
      e.preventDefault();
    }
    const input = this.inputTarget;
    const value = parseInt(input.value, 10);

    if (isNaN(value) || value <= 0) {
      const errorDiv = document.getElementById("error_message");
      errorDiv.textContent =
        "Solo se aceptan números enteros positivos";
      errorDiv.style.display = "block";
      return;
    }

    const submitBtn = this.submitButtonTarget;
    const originalText = submitBtn.textContent;

    submitBtn.disabled = true;
    submitBtn.textContent = "Guardando...";

    const formData = new FormData();

    formData.append("dias_por_vencer", value);

    const csrfToken = document
      .querySelector('meta[name="csrf-token"]')
      ?.getAttribute("content");

    fetch("/internaciones/configurar_dias_por_vencer", {
      method: "POST",
      body: formData,
      headers: {
        ...(csrfToken && { "X-CSRF-Token": csrfToken }),
        Accept: "application/json",
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          const errorDiv = document.getElementById("error_message");

          errorDiv.className = "text-success mt-2";
          errorDiv.textContent = data.message;
          errorDiv.style.display = "block";

          setTimeout(() => {
            const modalElement = document.querySelector(
              "[data-controller='turbo-modal']"
            );

            if (modalElement) {
              modalElement.remove();
            }
            const serviciosTab = document.querySelector(
              'a[data-tab-id="servicios"]'
            );
            
            if (serviciosTab) {
              serviciosTab.click();
            }
          }, 1500);
        } else {
          throw data;
        }
        
        if (internacion != "true") {
          window.location.reload();
        }
      })
      .catch((error) => {
        console.error(error);

        const errorDiv = document.getElementById("error_message");

        errorDiv.className = "text-danger mt-2";
        errorDiv.textContent =
          error.message ||
          "Error al guardar la configuración.";

        errorDiv.style.display = "block";

        submitBtn.disabled = false;
        submitBtn.textContent = originalText;
      });
  }
}